import { Box, Image, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ASSETS } from '../../../assets';
import { appColors } from '../../../constants/theme';
import { t } from '../../../locales/locales';

const PreviewTop = () => {
  const navigate = useNavigate();
  return (
    <VStack pt={{ base: '8', md: '12', lg: '55' }} position="relative">
      <Box
        position="relative"
        maxW={{ base: '220px', md: '280px', lg: '320px' }}
        overflow="visible"
      >
        <Image
          src={ASSETS.images.profile}
          alt={t('name')}
          w="80%"
          h="auto"
          borderRadius="lg"
          boxShadow="0 10px 30px rgba(0,0,0,0.3)"
          transition="transform 0.3s ease"
          _hover={{ transform: 'scale(1.05)' }}
          objectFit="cover"
          style={{
            maskImage:
              'linear-gradient(to bottom, black 70%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(to bottom, black 70%, transparent 100%)',
          }}
        />
      </Box>
      <Box
        position="absolute"
        bottom="0"
        bgGradient={`linear(to-t, ${appColors.mainBg}, transparent)`}
        textAlign="center"
        borderRadius="0 0 50% 50% / 20px"
      >
        <Text
          fontWeight="bold"
          color="white"
          fontSize={{ base: 'xl', md: '2xl' }}
          fontFamily="Cairo, sans-serif"
          textShadow="0 2px 4px rgba(0,0,0,0.5)"
          mb={2}
        >
          {t('name')}
        </Text>
        <Text
          color="white"
          fontFamily="Cairo, sans-serif"
          fontSize={{ base: 'xs', md: 'xs' }}
          lineHeight="1.4"
          mb={2}
          opacity={0.95}
          maxW={{ base: '300px', md: '300px', lg: '340px' }}
        >
          {t('preview')?.slice(0, 149)}...{' '}
          <Text
            as="span"
            color={appColors.primary}
            cursor="pointer"
            fontWeight="600"
            _hover={{ textDecoration: 'underline' }}
            onClick={() => navigate('/profile')}
          >
            {t('showMore')}
          </Text>
        </Text>
      </Box>
    </VStack>
  );
};

export default PreviewTop;
